import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Card, CardContent } from '@guildeducationinc/recess';
import ArrowBackIcon from '@guildeducationinc/recess/icons/ArrowBackIcon';
import { AdminTopNav } from '@src/components/Admin/AdminTopNav';
import { EditMacro } from '@src/components/Admin/EditMacro/EditMacro';
import { useMacros } from '@src/hooks/useMacros';
import { useLocale } from 'pe-core-frontend';
import { Link, useNavigate, useParams } from 'react-router-dom';
export const Macro = () => {
    const navigate = useNavigate();
    const { t } = useLocale();
    const { id } = useParams();
    const isNew = id === 'new';
    const { macros } = useMacros({ id: parseInt(id ?? ''), skip: isNew });
    const macro = id === 'new'
        ? {
            id: 0,
            category: '',
            title: '',
            content: '',
            isGeneric: true,
            tags: [],
        }
        : macros[0];
    return (_jsxs("div", { children: [_jsx(AdminTopNav, { title: id === 'new' ? t('Add Macro') : t('Edit Macro'), actions: _jsx("div", { children: _jsxs(Link, { to: '#', className: 'flex ml-8', onClick: () => navigate(-1), children: [_jsx(ArrowBackIcon, { size: 20 }), " ", t('Back')] }) }) }), _jsx("div", { children: _jsx(Card, { children: _jsx(CardContent, { children: macro && _jsx(EditMacro, { macro: macro }) }) }) })] }));
};
